import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { mapDispatchToProps, mapStateToProps, Props } from 'component/page/search/SortAndFilter/SortAndFilterOverlay/SortAndFilterOverlay.selectors';
import ContentArea from 'component/common/ContentArea/ContentArea';
import PageContainer from 'component/common/PageContainer/PageContainer';
import { withErrorBoundary } from 'component/common/Hoc/ErrorBoundary';
import { Box, FullScreenSheet, Icon, Typography } from '@drone-js/core';
import { getSortAndFilterQueryString } from 'component/page/search/SortAndFilter/sortAndFilterQuery.utils';
import { searchInitialState } from 'component/page/search/store/search';
import SortAndFilterContent from 'component/page/search/SortAndFilter/SortAndFilterContent';
import { FilterState } from 'component/common/Filter/Filter.types';
import { Sort } from 'gql/autogen/Sort';
import { SortAndFilterContentVariant } from 'component/page/search/SortAndFilter/SortAndFilterContent.selectors';
import FilterButtonsStickyFooter from 'component/page/search/SortAndFilter/SortAndFilterOverlay/FilterButtonsStickyFooter';

const SortAndFilterOverlay: React.FC<Props> = (props) => {
    const locationSearch = useLocation().search;
    const navigation = useNavigate();
    const [sortState, setSortState] = React.useState(props.sort);
    const [filterState, setFilterState] = React.useState(props.filter);

    const navigateAndClose = (sorting: Sort, filtering: FilterState) => {
        const query = getSortAndFilterQueryString(locationSearch, sorting, filtering, true);
        navigation(`?${query}`, { replace: props.isFilterWithoutUpdatingHistory });
        props.onClose();
    };

    const onClearButtonClick = () => {
        props.clearSortAndFilter(SortAndFilterContentVariant.Overlay);
        navigateAndClose(searchInitialState.sort, searchInitialState.filter);
    };

    const onFilterWithSidebarButtonClick = () => {
        props.setSortAndFilter(props.page, sortState, filterState, SortAndFilterContentVariant.Overlay);
        navigateAndClose(sortState, filterState);
    };

    return (
        <FullScreenSheet visible={props.visible} onClose={props.onClose} zIndex={1070}>
            <Box display="flex" position="sticky" top="0" backgroundColor="base.surface" flexDirection="column" boxShadow="bottom-s" px="16" pb="12" zIndex={1070}>
                <Box display="flex" alignItems="center" flexDirection="row" mt="16" mb="8">
                    <Box data-testid="activities-custom-sheet-close-button" as="button" width="fit-content" onClick={props.onClickBack} p="0" pe="12">
                        <Icon id="fill.arrow.thin-left" size="20" label={props.cms[126815]} />
                    </Box>
                    <Typography variant="heading-default">{props.cms[146522]}</Typography>
                </Box>
            </Box>
            <PageContainer data-testid="activities-sort-and-filter" flex={1} overflowY={props.isSubcategoryFilterEnabled ? 'visible' : 'auto'}>
                <ContentArea display={props.visible ? 'block' : 'none'} flex={1} px="16" pb="32" backgroundColor="base.surface" m="auto" width="100%">
                    <Box pt="32">
                        <SortAndFilterContent
                            variant={SortAndFilterContentVariant.Overlay}
                            visible={props.visible}
                            onFilterStateChange={setFilterState}
                            onSortStateChange={setSortState}
                        />
                    </Box>
                </ContentArea>
            </PageContainer>
            <FilterButtonsStickyFooter
                onClearButtonClick={onClearButtonClick}
                onFilterWithSidebarButtonClick={onFilterWithSidebarButtonClick}
                cms={props.cms}
                visible={props.visible}
            />
        </FullScreenSheet>
    );
};
SortAndFilterOverlay.displayName = 'SortAndFilterOverlay';

export default connect(mapStateToProps, mapDispatchToProps)(withErrorBoundary(SortAndFilterOverlay));
